import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const deleteOffer = {
    namespaced: true,
    state: {
        isLoadingDeclineModal: false,
        modalDeclineData: {},
        isShowDeclineModal: false,
        modalDeclineInfoData: {},
        isShowDeclineModalInfo: false
    },
    mutations: {
        SHOW_MODAL_DECLINE_DATA(state, modalDeclineData) {
            state.modalDeclineData.typeInfo = "primary";
            state.modalDeclineData.head = modalDeclineData.languageData.head;
            state.modalDeclineData.btnAgreeText = modalDeclineData.languageData.btnAgreeText;
            state.modalDeclineData.textInfo = modalDeclineData.languageData.textInfo+' '+modalDeclineData.id;
            state.modalDeclineData.idData = modalDeclineData.id;
            state.isShowDeclineModal = true;
        },
        DECLINE_OFFER_SUCCESS(state, declineData) {
            state.modalDeclineInfoData.typeInfo = "green";
            state.modalDeclineInfoData.head = declineData.result.data.message;
            state.modalDeclineInfoData.textInfo = declineData.result.data.data.textInfo;
            localStorage.setItem("messageDeclineOffer", declineData.result.data.message);
            localStorage.setItem("textDeclineOffer", declineData.result.data.data.textInfo);
            eventBus.$emit("declineOfferSuccess");

        },
        DECLINE_OFFER_FAILURE(state, error) {
            console.log(error);
            eventBus.$emit("declineOfferFailure", error.response.data.errors);
        },
        HIDE_MODAL_DECLINE_ACTION(state, value) {
            state.isShowDeclineModal = value;
        },
        HIDE_MODAL_DECLINE_INFO_ACTION(state, value) {
            state.isShowDeclineModalInfo = value;
        }
    },
    actions: {
        showModalDeclineData: function({commit}, modalDeclineData) {
            commit("SHOW_MODAL_DECLINE_DATA", modalDeclineData);
        },
        declineOfferRequest: function({state, dispatch}, value) {
            state.isLoadingDeclineModal = true;
            let promise = sendRequest("put", config.baseURLApi + "/offers/decline/" + value, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    let declineData = {};
                    declineData.result = result[1];
                    declineData.id = value;
                    dispatch("successDeclineOffer", declineData);
                } else {
                    dispatch("failureDeclineOffer", result[1]);
                }
                state.isLoadingDeclineModal = false;
                state.isShowDeclineModal = false;
                state.isShowDeclineModalInfo = true;
            })
        },
        successDeclineOffer: function({commit}, response) {
            commit("DECLINE_OFFER_SUCCESS", response);
        },
        failureDeclineOffer: function({commit}, error) {
            commit("DECLINE_OFFER_FAILURE", error);
        },
        hideModalDeclineAction({ commit }) {
            commit("HIDE_MODAL_DECLINE_ACTION", false);
        },
        hideModalDeclineInfoAction({ commit }) {
            commit("HIDE_MODAL_DECLINE_INFO_ACTION", false);
        }
    }
}

export default deleteOffer;